import { NavLink } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getFeaturedProducts } from "@/data/products";
import { ProductCard } from "@/components/ProductCard";

export function FeaturedProducts() {
  const featured = getFeaturedProducts();

  return (
    <section className="py-10 md:py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-6 md:mb-14">
          <div>
            <p className="text-[10px] sm:text-[11px] tracking-[0.3em] uppercase text-emerald-600 font-semibold mb-2 md:mb-3">Selezione Brupa</p>
            <h2 className="text-xl sm:text-2xl md:text-5xl text-stone-900 font-semibold md:font-bold tracking-tight leading-[1.05]">I più amati</h2>
          </div>
          <div className="hidden sm:flex items-center gap-5">
            <NavLink
              to="/donna"
              className="flex items-center gap-1.5 text-xs tracking-widest uppercase text-stone-500 hover:text-stone-900 border-b border-stone-300 hover:border-stone-900 pb-0.5 transition-colors"
            >
              Donna <ArrowRight className="size-3" />
            </NavLink>
            <NavLink
              to="/uomo"
              className="flex items-center gap-1.5 text-xs tracking-widest uppercase text-stone-500 hover:text-stone-900 border-b border-stone-300 hover:border-stone-900 pb-0.5 transition-colors"
            >
              Uomo <ArrowRight className="size-3" />
            </NavLink>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-3 md:gap-4">
          {featured.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 sm:hidden">
          <NavLink
            to="/donna"
            className="inline-flex items-center gap-1.5 text-xs tracking-widest uppercase text-stone-600 border-b border-stone-400 pb-0.5"
          >
            Donna <ArrowRight className="size-3" />
          </NavLink>
          <NavLink
            to="/uomo"
            className="inline-flex items-center gap-1.5 text-xs tracking-widest uppercase text-stone-600 border-b border-stone-400 pb-0.5"
          >
            Uomo <ArrowRight className="size-3" />
          </NavLink>
        </div>
      </div>
    </section>
  );
}
